import { ActivityEmail } from "../../../components/ActivityEmailDisplay";
import { ActivityPluginProps } from "../../registry/ActivityPluginTypes";

export const ActivityEmailCard = ({
  data,
  reload,
  reloadClientDetail
}: ActivityPluginProps) => {
  return (
    <ActivityEmail
      data={data}
      reload={() => reload()}
      reloadClientDetail={reloadClientDetail}
    />
  );
};
